<div class="main-layout">
    <app-left-nav></app-left-nav>

    <div class="main-content">
        <app-header></app-header>
        <div class="page-content">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>